import isEmailValid from '../../../validation/emailValidation';

export default function isEmailFieldValid(email) {
  return isEmailValid(email);
}
